import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'nexus-vs-zero-state',
    imports: [],
    templateUrl: './zero-state.component.html',
    styleUrl: './zero-state.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZeroStateComponent {
  @Input() message = '';
}
